import React, { useState, useEffect } from "react";
import { Box, Card, Typography, Button, Tooltip } from "@mui/material";
import { PulseLoader } from "react-spinners"; // Importing the loader

import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { CasesColumns } from "../../../data/DynamicTable/Collumns";
import { caseManagementUrl } from "../../../config";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../theme";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";
import { UploadDocumentComponent } from "../../../data/DynamicTable/Modal";
import { downloadCaseForClientFile } from "../../../data/DynamicTable/DynamicFunctions";
import { CloudUploadIcon } from "lucide-react";
import CasesForm from "../../CaseManagement/Form";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const base_url = caseManagementUrl.uri;

function CasesByIndividualClients(props) {
  const data = JSON.parse(localStorage.getItem("IndividualclientData"));
  const totalData = data.length;
  const [countData, setCountData] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [dialogOpen, setDialogOpen] = useState(false);
  const isClientActive = data?.isActive === 1 || data?.isActive === true;
  const handleOpenModal = () => {
    if (!isClientActive) {
      alert("Cannot upload documents for an inactive client.");
      return;
    }
    setDialogOpen(true);
  };
  const handleBack = () => {
    window.history.back();
  };
  
  const ClientId = data.id;

    useEffect(() => {
      async function fetchAllData() {
        try {
          const returnFields = null;
          const inputFields = { clientTypeId: 1, clientId: data.id };
          const Facts = await fetchDataEngine(
            "caseCountByClientId",
            "countParams",
            inputFields,
            returnFields,
            base_url
          );
          setCountData(Facts);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
      fetchAllData();
    }, []);
  const actions = {
    entity: "Cases",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: false,
      permission: "EditPermission",
    },

    add: {
      key: "ADD",
      button_name: "File New Case",
      Show_Button: false,
      permission: "CreatePermission",
      inputObjectName: "createCaseDynamic",
      InputObject: "newCase",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
      inputObjectName: "acivateDeactivateCase",
    },
    ViewCase: {
      key: "VIEWDETAILS",
      button_name: "View Details",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    updateCaseStatus: {
      key: "UPDATECASESTATUS",
      button_name: "Update Case Status",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    modelName: "Cases",
    showStatus: true,
    dataObject: {
      inputFields: {
        clientId: data.id,
      },
      inputObjectName: "allCasesByColumnValues",
      inputSubObjectName: "casesViewModel",
      returnFields: [
        "id",
        "clientType",
        "clientTypeId",
        "caseNumber",
        "title",
        "description",
        "summary",
        "categoryName",
        "caseCategoryId",
        "caseSubCategoryId",
        "subcategoryName",
        "caseStatus",
        "dateOpened",
        "dateClosed",
        "priority",
        "isActive",
        "statusFlag",
        "createdBy",
        "createdDate",
        "updatedBy",
        "updatedDate",
        "isInvoiced",
        "companyId",
        "company",
        "regionId",
        "branchId",
        "individualFirstName",
        "individualLastName",
        "corporateCompanyName",
        "workFlow",
        "name",
        "clientId",
      ],
    },
  };
 const title = `${data.firstName || ""} ${data.lastName || ""} Files`;

  const subtitle = `View All Files For ${data.firstName}  `;
  const handleDownload = async () => {
    await downloadCaseForClientFile();
  };
  return (
    <Box m="5px" p="1rem">
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={handleBack}
        sx={{
          backgroundColor: colors.greenAccent[700],
          '&:hover': { backgroundColor: colors.greenAccent[500] },
        }}
      >
        Back
      </Button>

      <Box
        m="2px"
        //p="1rem"
        sx={{
          display: "flex",
          justifyContent: "end",
          // alignItems: "center",
          // height: "100vh",
        }}
      >
        <Card
          sx={{
            minWidth: 275,
            backgroundColor: colors.primary[400],
          }}
        >
          <CardContent>
            <Typography
              sx={{ fontSize: 18 }}
              color={colors.greenAccent[500]}
              gutterBottom
            >
              Total Number of files for {data.firstName} is :{""}
              <Box component="span" color={colors.redAccent[400]}>
                {countData}
              </Box>
            </Typography>
            {!isClientActive && (
              <Typography
                sx={{ fontSize: 14, mt: 1 }}
                color={colors.redAccent[400]}
              >
                Note: This client is currently inactive.
              </Typography>
            )}
          </CardContent>
        </Card>
        <Box
          m="2px"
          sx={{
            justifyContent: "end",
            alignItems: "center",
            display: "flex",
          }}
        >
          {" "}
          <Typography
            style={{ color: colors.greenAccent[400], margin: "0 8px" }}
          >
            Import Files for {data.firstName || ""} {data.lastName || ""}
          </Typography>
          <Tooltip
            title={!isClientActive ? "Cannot upload documents for an inactive client." : ""}
            arrow
          >
            <span>
              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
                disabled={!isClientActive}
                sx={{
                backgroundColor: isClientActive
                  ? colors.greenAccent[500]
                  : colors.grey[700],
                borderRadius: "4px",
                m: "10px",
                '&:hover': {
                  backgroundColor: isClientActive
                    ? colors.greenAccent[300]
                    : colors.grey[500],
                },
                '&.Mui-disabled': {
                  backgroundColor: colors.grey[700],
                  color: colors.grey[400],
                },
                }}
                onClick={handleOpenModal}
              >
                <Typography style={{ color: colors.primary[400], margin: "0 8px" }}>
                  Import
                </Typography>
              </Button>
            </span>
          </Tooltip>
        </Box>
      </Box>

      <DynamicTable
        title={title}
        subtitle={subtitle}
        columns={CasesColumns}
         FormComponent={CasesForm}
        //query={allCasesView}
        base_url={base_url}
        actions={actions}
      />
      <UploadDocumentComponent
        uploadType="individual"
        ClientId={ClientId}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
      {/* //)} */}
    </Box>
  );
}

export default CasesByIndividualClients;
